/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px 0 15px 0;
`;
